<!-- 表1填写 -->

<template>
  <div class="tabCage table3">
    <div class="tabTtl">
      <span>表 1-3：经营情况表</span>
      <!-- <el-select v-model="value" clearable placeholder="历史版本列表" class="selectTime" @change="gethistory(value)">
				<el-option v-for="item in options" :key="item.id" :label="item.value" :value="item.id">
									</el-option>
								</el-select> -->
    </div>

    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea editBox">
        <table :class="value !== '' ? 'newStyle' : ''">
          <tr>
            <td colspan="2">项目</td>
            <td>{{ yearSet.year1 }}年</td>
            <td>{{ yearSet.year2 }}年</td>
          </tr>
          <tr>
            <td colspan="2">出版单位年销售收入（万元）</td>
            <td>
              <el-input-number
                v-model="params.firstTotalSales"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondTotalSales"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td colspan="2">出版单位年利润(税后)总额（万元）</td>
            <td>
              <el-input-number
                v-model="params.firstTotalProfit"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondTotalProfit"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td rowspan="6">
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>年度销售收入（万元）
            </td>
            <td>
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>发行和销售收入
            </td>
            <td>
              <el-input-number
                v-model="params.firstSales1"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondSales1"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>出让版权的收入</td>
            <td>
              <el-input-number
                v-model="params.firstSales2"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondSales2"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>出版活动收入</td>
            <td>
              <el-input-number
                v-model="params.firstSales3"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondSales3"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>提供内容审校加工等<br />各种服务的收入</td>
            <td>
              <el-input-number
                v-model="params.firstSales4"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondSales4"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>其他收入</td>
            <td>
              <el-input-number
                v-model="params.firstSales5"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondSales5"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>合计</td>
            <td>
              <el-input-number
                v-model="params.firstSales"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondSales"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td rowspan="9">
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>年度支出（万元）
            </td>
            <td>
              <span v-if="pressType == 1">音像</span
              ><span v-else-if="pressType == 2">电子</span>出版团队的<br />人员成本费用<br />（包括工资、福利、奖金等）
            </td>
            <td>
              <el-input-number
                v-model="params.firstPay1"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondPay1"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>房租水电等<br />运营成本费用</td>
            <td>
              <el-input-number
                v-model="params.firstPay2"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondPay2"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>获取内容及<br />审校加工等<br />各种劳务的支出</td>
            <td>
              <el-input-number
                v-model="params.firstPay3"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondPay3"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>印刷压盘<br />包装等费用</td>
            <td>
              <el-input-number
                v-model="params.firstPay4"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondPay4"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>新媒体上的投入</td>
            <td>
              <el-input-number
                v-model="params.firstPay5"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondPay5"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>固定资产投入</td>
            <td>
              <el-input-number
                v-model="params.firstPay6"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondPay6"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>培训支出</td>
            <td>
              <el-input-number
                v-model="params.firstPay7"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondPay7"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>其他支出</td>
            <td>
              <el-input-number
                v-model="params.firstPay8"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondPay8"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>合计</td>
            <td>
              <el-input-number v-model="params.firstPay" disabled controls-position="right" :precision="2" size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondPay"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>年税费（万元）
              <br />
              <span style="color: red"
                >指与<span v-if="pressType == 1">音像制品</span
                ><span v-else-if="pressType == 2">电子出版</span>相关的企业所得缴纳税费，含营业税和所得税</span
              >
            </td>
            <td>
              <el-input-number v-model="params.firstTax" disabled controls-position="right" :precision="2" size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondTax"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>年度利润（税后）总额（万元）
            </td>
            <td>
              <el-input-number
                v-model="params.firstProfit"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondProfit"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td colspan="2">获得基金类资助（万元）</td>
            <td>
              <el-input-number
                v-model="params.firstFund"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondFund"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td colspan="2">主办主管单位给与的经费支持（万元）</td>
            <td>
              <el-input-number
                v-model="params.firstSuperior"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondSuperior"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td rowspan="3">
              <span v-if="pressType == 1">音像制品</span><span v-else-if="pressType == 2">电子出版物</span>出版品种
            </td>
            <td>载体出版</td>
            <td>
              <el-input-number
                v-model="params.firstZtcbVariety"
                disabled
                controls-position="right"
                :min="0"
                :precision="0"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondZtcbVariety"
                disabled
                controls-position="right"
                :min="0"
                :precision="0"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>信息网络出版</td>
            <td>
              <el-input-number
                v-model="params.firstWlcbVariety"
                disabled
                controls-position="right"
                :min="0"
                :precision="0"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondWlcbVariety"
                disabled
                controls-position="right"
                :min="0"
                :precision="0"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>总计</td>
            <td>
              <el-input-number
                v-model="params.firstPublicationVariety"
                disabled
                controls-position="right"
                :min="0"
                :precision="0"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondPublicationVariety"
                disabled
                controls-position="right"
                :min="0"
                :precision="0"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td rowspan="3">
              <span v-if="pressType == 1">音像制品</span
              ><span v-else-if="pressType == 2">电子出版物</span>经营情况<br />载体出版
            </td>
            <td>销售数量（套/张）</td>
            <td>
              <el-input-number
                v-model="params.firstSalesVolumes"
                disabled
                controls-position="right"
                :min="0"
                :precision="0"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondSalesVolumes"
                disabled
                controls-position="right"
                :min="0"
                :precision="0"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>年销售收入（万元）</td>
            <td>
              <el-input-number
                v-model="params.firstZtcbSales"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondZtcbSales"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>年利润总额（万元）</td>
            <td>
              <el-input-number
                v-model="params.firstZtcbProfit"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondZtcbProfit"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td rowspan="5">
              <span v-if="pressType == 1">音像制品</span><span v-else-if="pressType == 2">电子出版物</span>
              <br />载体出版发行的渠道及占比

              <br /><span style="color: red">（请填写%之前的数值）</span>
            </td>
            <td>新华书店%</td>
            <td>
              <el-input-number
                v-model="params.firstZtcbDistributionChanne"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondZtcbDistributionChanne"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>馆配商%</td>
            <td>
              <el-input-number
                v-model="params.firstZtcbDistributionChanne1"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondZtcbDistributionChanne1"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>邮局%</td>
            <td>
              <el-input-number
                v-model="params.firstZtcbDistributionChanne2"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondZtcbDistributionChanne2"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>其他%</td>
            <td>
              <el-input-number
                v-model="params.firstZtcbDistributionChanne3"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondZtcbDistributionChanne3"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>自办发行%</td>
            <td>
              <el-input-number
                v-model="params.firstZtcbDistributionChanne4"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondZtcbDistributionChanne4"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td rowspan="2">
              <span v-if="pressType == 1">音像制品</span>
              <span v-else-if="pressType == 2">电子出版物</span>经营情况<br />
              信息网络出版
            </td>
            <td>年销售收入（万元）</td>
            <td>
              <el-input-number
                v-model="params.firstWlcbSales"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondWlcbSales"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>年利润总额（万元）</td>
            <td>
              <el-input-number
                v-model="params.firstWlcbProfit"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondWlcbProfit"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td rowspan="2">
              <span v-if="pressType == 1">音像制品</span><span v-else-if="pressType == 2">电子出版物</span>
              <br />信息网络出版渠道及占比 <br /><span style="color: red">（请填写%之前的数值）</span>
            </td>
            <td>互联网网络营销平台%</td>
            <td>
              <el-input-number
                v-model="params.firstWlcbDistributionChanne"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondWlcbDistributionChanne"
                disabled
                controls-position="right"
                :min="0"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
          <tr>
            <td>自办发行%</td>
            <td>
              <el-input-number
                v-model="params.firstWlcbDistributionChanne1"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
            <td>
              <el-input-number
                v-model="params.secondWlcbDistributionChanne1"
                disabled
                controls-position="right"
                :precision="2"
                size="small">
              </el-input-number>
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea newEditArea">
        <div class="editBox">
          <p class="edName">申报人：</p>
          <div class="edInp">
            <el-input size="small" v-model="declare.personnel" disabled placeholder="请输入申报人"></el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">联系方式：</p>
          <div class="edInp">
            <el-input size="small" v-model="declare.contact" disabled placeholder="请输入申报人联系方式"></el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">申报时间：</p>
          <div class="edInp">
            <el-input size="small" v-model="params.updatedAt" disabled></el-input>
          </div>
        </div>
      </div>
    </el-form>
    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt3";
import { tabUpdate3, tabRead3, pSubmitHistoryList } from "@/api/pressRole/pressRole";
import Upbtn from "@/views/components/uploadCards";
export default {
  components: {
    Upbtn,
  },
  data() {
    return {
      pressType: this.$route.query.pressType,
      params: bsParams,
      rules: paramsRule,
      submiting: false,
      yearSet: {
        year1: "",
        year2: "",
      },
      value: "",
      historyJson: [],
      historyJsonParams: {}, // 提交的历史数据json
      historyImgUrl: "", // 提交的历史数据里的img地址
      declare: {
        personnel: "",
        contact: "",
      },
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: "",
      },
    };
  },
  methods: {
    tabReEdit: function () {
      tabRead3({ publishMaterialId: this.$route.query.mtId }).then((response) => {
        this.params = response.pfinance;

        // 处理年份
        this.yearSet.year1 = this.params.firstYear;
        this.yearSet.year2 = Number(this.params.firstYear) + 1;

        if (response.pOrganizationPersonnel !== null) {
          this.declare.contact = response.pOrganizationPersonnel.contact;
          this.declare.personnel = response.pOrganizationPersonnel.personnel;
          this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },

    // 获取出版单位历史提交版本列表
    getHistoryList: function () {
      let that = this;
      pSubmitHistoryList({ publishMaterialId: this.$route.query.mtId }).then((response) => {
        that.historyJson = response.pSubmitHistoryList;
        for (const list of response.pSubmitHistoryList) {
          that.options.push({ value: list.createdAt, id: list.id });
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function (id) {
      const that = this;
      for (const list of that.historyJson) {
        if (id == list.id) {
          that.historyJsonParams = JSON.parse(list.afterJson);
          that.historyDeclare = JSON.parse(list.submittor);
        }
      }
      // 获取图片
      getFileToken().then((data) => {
        that.historyImgUrl =
          process.env.BASE_API +
          "/File/File/download/token/" +
          data.resultStatus.token +
          "/id/" +
          that.historyJsonParams.yyzzId;
      });
    },
    goBack: function () {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getHistoryList();
  },
  created: function () {
    this.tabReEdit();
    // let newDate = new Date();
    // this.yearSet.year1 = newDate.getFullYear() - 2;
    // this.yearSet.year2 = newDate.getFullYear() - 1;
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table3 {
  .highlight {
    .el-input__inner,
    .el-textarea__inner {
      color: red !important;
    }
  }

  .selectTime {
    float: right;
    font-weight: normal;
  }

  .el-form {
    width: 100%;
    overflow: auto;
  }

  .editBox {
    width: 100%;
    overflow-x: auto;
    /*overflow-y: hidden;*/
    white-space: nowrap;
    /*height: 600px;*/
  }

  .newStyle {
    margin: 30px 0 !important;
    width: auto !important;
    overflow-x: hidden;
    float: left;
  }
}

.table3 .editArea {
  text-align: center;
}

.table3 .editArea table {
  width: 80%;
  margin: 30px auto;
  border-collapse: collapse;
}

.table3 .editArea table td {
  border: 1px solid #e8e8e8;
  height: 45px;
}

.table3 .el-input-number {
  width: 240px;
}

.el-input-number input {
  border-radius: 0px;
}

.table3 .newEditArea {
  width: 80%;
  margin: 0 auto;
  padding: 30px;

  .editBox {
    width: 100%;
    height: auto;
    overflow: hidden;

    p {
      float: left;
      width: 100px;
      text-align: right;
    }

    .edInp {
      width: 300px;
      float: left;
      margin: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// table3.vue?38eaa739